import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./Components/Pages/Home";
import Navbar from "./Components/Layout/Navbar";
import Footer from "./Components/Layout/Footer";
import Services from "./Components/Pages/Services";
import Portfolio from "./Components/Pages/Portfolio";
import About from "./Components/Pages/About";
import Contact from "./Components/Pages/Contact";
const App = () => {
  return (
    <>
      <BrowserRouter>
      <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer/> 
      </BrowserRouter>
    </>
  );
};

export default App;
